import { on, off } from '@/public/components/kye-table2/utils/dom.js'

const eventMap = {
  mousedown: 'mousedown',
  mouseup: 'mouseup',
  mousemove: 'mousemove',
  mouseover: 'mouseover'
}

const classNameMap = {
  rowTableClass: '.virtual-grid__inner__table__row',
  leftTableClass: '.kye-table-v2__left-table',
  checkBoxColumnClass: '.table2_checkbox',
  checkBoxClassToVm: '.el-checkbox'
}

const lifecycleHooks = {
  beforeDestroy: 'hook:beforeDestroy'
}

const watchKeyName = 'showSelection'

class Table2BatchCheckboxDragSelect {
  constructor(option) {
    this.init(option)
  }

  init(option = {}) {
    this.initOption(option)
    this.initStates()
    this.bindHandlers()
    this.initEvent()
  }

  initOption(option) {
    const { vm: tableVm } = option
    this.tableEl = tableVm && tableVm.$el
    this.table2LeftEl = this.tableEl && this.tableEl.querySelector(classNameMap.leftTableClass)
    this.option = option
  }

  initStates() {
    this.states = {
      isMousedown: false,
      startRowIndex: null, // 拖动起点
      lastPaintedSet: new Set() // 已经处理过的行号，防止重复 toggle
    }
  }

  bindHandlers() {
    this.handleMousedown = this.handleMousedown.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.handleMousemove = this.handleMousemove.bind(this)
  }

  initEvent() {
    on(this.tableEl, eventMap.mousedown, this.handleMousedown)
    on(this.tableEl, eventMap.mouseup, this.handleMouseUp)
    document.addEventListener(eventMap.mouseup, this.handleMouseUp)
  }

  handleMousemove(event = {}) {
    if (!this.states.isMousedown) return
    const table2CheckboxVm = this.getCheckboxVm(event.target)
    const rowIndex = table2CheckboxVm && table2CheckboxVm.rowIndex
    if (rowIndex == null) return

    // 同一帧不重复处理
    if (this.states.startRowIndex === rowIndex) return

    // 第一次进入，记录起点，且当前单元格移动不执行勾选
    if (this.states.startRowIndex === null) {
      this.states.startRowIndex = rowIndex
      return
    }

    // 补帧：拿到本次应处理的所有行号
    const paintSet = this.recordRows(
      this.states.startRowIndex,
      rowIndex
    )

    // 先清除掉上一次已处理、但本次不在范围内的行
    this.states.lastPaintedSet.forEach(idx => {
      if (!paintSet.has(idx)) {
        this.toggleRow(idx)
      }
    })

    // 统一设置本次状态
    paintSet.forEach(idx => {
      if (!this.states.lastPaintedSet.has(idx)) {
        this.toggleRow(idx)
      }
    })

    this.states.lastPaintedSet = paintSet
  }

  // 记录所有鼠标经过的行 Set<行号>
  recordRows(start, end) {
    const set = new Set()
    const step = start <= end ? 1 : -1
    for (let i = start; i !== end + step; i += step) {
      set.add(i)
    }
    return set
  }

  // 真正执行勾选/取消
  toggleRow(rowIndex) {
    const vm = this.getCheckboxVmByIndex(rowIndex)
    if (vm && vm.handleMousemove) {
      vm.handleMousemove()
    }
  }

  // 根据行号拿到 checkbox 组件实例
  getCheckboxVmByIndex(index) {
    const leftTable = this.table2LeftEl
    if (!leftTable) return null
    const rowEl = leftTable.querySelector(classNameMap.rowTableClass + `.row-${index}`)
    if (!rowEl) return null
    const checkboxEl = rowEl.querySelector(classNameMap.checkBoxClassToVm)
    let vm = (checkboxEl && checkboxEl.__vue__) || {}
    // $parent 属于勾选状态
    return vm.handleMousemove ? vm : vm.$parent
  }

  getCheckboxVm(el) {
    const table2CheckboxWrap = el && el.closest(classNameMap.checkBoxColumnClass)
    if (table2CheckboxWrap) {
      const checkboxEl = table2CheckboxWrap.querySelector(classNameMap.checkBoxClassToVm)
      let vm = (checkboxEl && checkboxEl.__vue__) || {}
      // $parent 属于勾选状态
      return vm.handleMousemove ? vm : vm.$parent
    }
    return null
  }

  handleMousedown() {
    this.states.isMousedown = true
    if (!this.table2LeftEl) {
      this.getLeftTableEl()
    }
    on(this.table2LeftEl, eventMap.mousemove, this.handleMousemove)
  }

  handleMouseUp() {
    this.states.isMousedown = false
    this.states.startRowIndex = null
    this.states.lastPaintedSet.clear()
    off(this.table2LeftEl, eventMap.mousemove, this.handleMousemove)
  }

  getLeftTableEl() {
    this.table2LeftEl = this.tableEl && this.tableEl.querySelector(classNameMap.leftTableClass)
  }

  destroy() {
    off(this.tableEl, eventMap.mousedown, this.handleMousedown)
    off(this.tableEl, eventMap.mouseup, this.handleMouseUp)
    document.removeEventListener(eventMap.mouseup, this.handleMouseUp)
  }
}

export function createBatchCheckboxDragSelect(vm) {
  if (!vm) return

  const watchOption = {
    immediate: true
  }

  let batchCheckboxDragSelect = null

  const unWatch = vm.$watch(
    watchKeyName,
    isStart => {
      batchCheckboxDragSelect && batchCheckboxDragSelect.destroy()
      if (isStart) {
        batchCheckboxDragSelect = new Table2BatchCheckboxDragSelect({ vm })
      }
    },
    watchOption
  )

  vm.$on(lifecycleHooks.beforeDestroy, () => {
    unWatch()
    batchCheckboxDragSelect && batchCheckboxDragSelect.destroy()
    batchCheckboxDragSelect = null
  })
}




// WEBPACK FOOTER //
// ./src/public/components/kye-table2/plugins/batch-checkbox-drag-select.js